<template>
  <div class="details relative-position">
    <div class="load-data-wrap col is-detail details_data_load" style="margin-top: 266px; display: none;">
      <div class="fit"></div>
      <div class="column yb-flex-center empty"></div>
    </div>
    <div class="wrap-handicap v-scroll-area-bar">
      <div class="screen">
        <div class="v-scroll-area fit vrow relative-position">
          <div class="content-wrap fit">
            <allBetHeader :mode="'ab'"></allBetHeader>
            <allBetContent :mode="'ab'"></allBetContent>
            <div class="scroll-footer" style="bottom: 0px;"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="refresh-mask absolute-full yb-flex-center" style="top: 36px;" v-show="allBetReloading">
      <div class="img-loading custom-format-img-loading"></div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import EventBus from '../../events/event-bus'
import DateFilter from '@/vue/filters/date'
import moment from 'moment'
import 'moment/locale/zh-cn'

// import OddComponents from '../../components/odd'
// import Odd1x2Components from '../../components/odd1x2'
// import HandicapComponents from '../../components/handicap'
// import OverUnderComponents from '../../components/over-under'
// import sportTime from './sportTimeColumn'
// import sportTeam from './sportTeamColumn'

import allBetComponent from './allBet/all-bet'
import allBetHeader from './allBetHeader'
import allBetContent from './allBetContent'
import allBetMixin from '@/vue/mixins/allBet'
import sportFavourite from '@/vue/mixins/favourite'

export default {
  mixins: [allBetMixin, sportFavourite],
  components: {
    allBetComponent,
    allBetHeader,
    allBetContent,
  },
  computed: {
    ...mapGetters([
      'sportTableLang',
      'sportAllBetLang',
      'matchAllBet',
      'sortedMatchEventList',
      'market',
      'selectedShow',
      'selectedMarket',
      'selectedBettype',
      'tvIconFlag',
      'selectedAllBetNew',
      'foldopenAllBet',
      'allBetReloading',
    ]),
    
  },
  watch: {
    'showhideBanner': {
      handler(val, oldVal) {
        this.allBet_mContent()
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      selectedLang: window._langid,
      lang: window.lang,
      fT: ['2', '3'],
      hT: ['2', '4'],
      showhideAll: true,
      selectedBetTab: 'hot',
      otherSport1: ['N3', 'N12', 'N21'],  //tennis,badminton,volleyball
      betTab: {
        hot: {
          key: 'hot',
          value: true,
          flag: true,
        },
        hdpou: {
          key: 'hdpou',
          value: [1,2,4,32,46,48], //bettype in allbet mixin
          rbvalue: [8,9,11,33,47,49],
          flag: true,
        },
        goals: {
          key: 'goals',
          value: [2, 3, 5], //bettype in allBet mixin
          rbvalue: [18, 9, 10],
          flag: true,
        },
        cs: {
          key: 'cs',
          value: [7], //bettype in allBet mixin
          rbvalue: [16],
          flag: true,
        },
        ft: {
          key: 'ft',
          value: [1], //plytyp in allbet mixin
          rbvalue: [8],
          flag: true,
        },
        ht: {
          key: 'ht',  //first half
          value: [2], //plytyp in allbet mixin
          flag: true,
        },
        sh: {
          key: 'sh',  //first half
          value: [19], //plytyp in allbet mixin
          flag: true,
        },
        others: {
          key: 'others',
          value: true,
          flag: true,
        },
        special: {
          key: 'special',
          value: true,
          flag: true,
        },
        other: {
          key: 'other',
          value: [21,34,28,30],
          rbvalue: [27,29,35,31],
          flag: true,
        },
        scrMarket: {
          key: 'scrMarket',
          value: [2, 3, 5, 7, 9, 10], //bettype in allBet mixin
          flag: true,
        },
        sethdp: {
          key: 'set',
          value: [3, 7, 8, 9, 10, 11, 12],
          rbvalue: [27,29,35,31],  //rbettype in allBet mixin
          flag: true,
        },
        gamehdp: {
          key: 'game',
          value: [6],
          flag: true,
        },
        pointhdp: {
          key: 'point',
          value: [4],
          flag: true,
        },
        all: {
          key: 'all',
          value: true,
          flag: true,
        },
        innings: {
          key: 'innings',
          value: [allBetMixin.data().first5InningsPlyType,
          allBetMixin.data().first3InningsPlyType,
          allBetMixin.data().firstInningsPlayType,
          allBetMixin.data().secondInningsPlyType,
          allBetMixin.data().thirdInningsPlyType,
          allBetMixin.data().fourthInningsPlyType,
          allBetMixin.data().fifthInningsPlyType,
          allBetMixin.data().sixthInningsPlyType,
          allBetMixin.data().seventhInningsPlyType,
          allBetMixin.data().eightthInningsPlayType,
          allBetMixin.data().nineInningsPlayType,
          allBetMixin.data().OTPlyType],
          flag: true,
        },
        team: {
          key: 'team',
          value: [80,82],
          rbvalue: [81,83],
          flag: true,
        },
        booking: {
          key: 'booking',
          value: ['7b','10a','23a'],
          flag: true,
        },
        corner: {
          key: 'corner',
          value: ['7a','9a','22a'],
          flag: true,
        },
      },
      showhideBanner: true,
      mContentPadding: '',
      reloading: false,
      bannerSize: 190,
    }
  },
  methods: {
    checkBTExist(BTkey) {
      let vue = this
      // let btKey = BTkey
      let exist = false
      let btArray = (this.sortedMatchEventList.rbinfo) ? vue.betTab[BTkey].rbvalue : vue.betTab[BTkey].value

      _.forEach(this.sortedMatchEventList.od, function (data, key) {
        _.forEach(data, function (val, k) {
          if ($.inArray(parseInt(k), btArray) > -1) {
            exist = true
          }
        })
      })

      return exist
    },
    allBet_mContent(){
      var a = 76
      var b = (this.showhideBanner) ? a + this.bannerSize : a

      this.mContentPadding = 'padding-top: '+b+'px;'
    },
    showhide_Banner(val){
      this.showhideBanner = val
      // this.allBet_mContent()
    },
    getABetSport() {
      var sprt = this.$store.getters.selectedBettype.sprtId

      return 'allBet'+sprt
    },
    foldopenAB() {
      this.$store.commit('FOLDOPEN_ALLBET', !this.$store.getters.foldopenAllBet)
    },
    // backtoTop() {
    //   // $('html, body').animate({
    //   //   scrollTop: 0
    //   // }, 400);
    //   $('.scroll-inner-wrap').animate({
    //     scrollTop: $('.wrap-scroll').position().top
    //   }, 400);
    // },
    showhideMain() {
      this.showhideAll = (this.showhideAll) ? false : true;
      this.$set(this.sortedMatchEventList, 'hide', !this.sortedMatchEventList.hide)
    },
    colspanS() {
      // return (this.selectedMarket == 3) ? 2 : 3
      return 2
    },
    getSubMatch(sub) {
      return sub + 1
    },
    showLeg() {
      this.$set(this.sortedMatchEventList, 'hide', !this.sortedMatchEventList.hide)
    },
    chooseBetTab(betTab) {
      if (betTab.flag) {
        this.selectedBetTab = betTab.key
      }
      // this.switchAllBetTab(id)
    },
    switchAllBetTab(id) {
      $('.moreBetTypeNav-Item').removeClass('active');
      $(id).addClass('active');
    },
    checkOpenMore(event) {
      if (event.sp) {
        return true;
      } else if (event.od) {
        var show = true
        $.each(event.od, function (plyTypes, drawBt) {
          if (plyTypes !== '1' && plyTypes !== '3') {
            return true;
          } else {
            show = true
            if (plyTypes == '1' || plyTypes == '2') {
              $.each(drawBt, function (bidx, drawDual) {
                show = true
                //HDP,OU,1x2,RHDP,ROU,R1x2,ML
                if (bidx == 1 || bidx == 2 || bidx == 4 || bidx == 8 || bidx == 9 || bidx == 11) {
                  show = false
                }
              });
            }
          }
        });
        return show;
      }
      return false;
    },
    reloadTable(token_val = '') {
      this.oddsReload = true
      // this.clearTimer()
      EventBus.$emit('templateChange', this.oddsReload);
      // this.reloadingPer = '25%';
      var dispatchName = 'getSportOdds'
      if (this.$store.getters.selectedBettype.betTypId == '6') { //if is outright
        dispatchName = 'getSportOutrightOdds'
      }
      if (token_val == '' || token_val == undefined) {
        token_val = token.arr_8
      }
      // this.reloadingPer = '80%';
      this.$store.dispatch(dispatchName, {
        token: token_val,
        callback: ((res) => {
          if (res.events) {
            // this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)
            // this.startTimer()
            // clearInterval(this.reconnectTimerId)
            this.reconnectTimerId = null
            _.forEach(res.events, function (val, key) {
              _.forEach(val, function (v, k) {
                var showAllBet = $('#moreExpand' + v.eveid).hasClass('icon-moreCollapse')
                if (showAllBet) {
                  $('#moreExpand' + v.eveid).addClass('icon-moreExpand')
                  $('#moreExpand' + v.eveid).removeClass('icon-moreCollapse')
                  $('#moreBets' + v.eveid).css("display", "none");
                }
              })
            })
          } else {
            this.reconnectTimerSeconds = 5;
            if (this.reconnectTimerId == null) {
              this.reconnectTimerId = setInterval(() => {
                if (this.reconnectTimerSeconds - 1 < 0) {
                  this.reloadTable()
                } else {
                  this.reconnectTimerSeconds -= 1;
                }
              }, 1000);
            }
          }
          if (this.showFavEvents) {
            this.$store.dispatch('getLaugueList', (function (res) {
              this.$store.commit('SELECTEDLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
              this.$store.commit('TOTALLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
            }).bind(this))
          }
          this.reloading = false
          this.oddsReload = false
          EventBus.$emit('templateChange', this.oddsReload);
          // this.refreshScroll()

          this.$store.commit('PARLAY_SELECTED', { update: false })
        }).bind(this)
      })
    },
    backToMain() {
      EventBus.$emit('sportTableReloading', true)
      this.reloadTable()
      this.$store.commit('SELECTED_MATCHALLBET', false)
    },
    clearTimer() {
      clearInterval(this.timerId)
      this.timerId = null
    },
    getMarketTimer(selMarket) {
			if (this.$store.getters.open_RBMarket) {
				return this.rbTimer
			} else if (selMarket == this.$store.getters.market.earlyMarket.key) {
				return this.earlyTimer
			} else if (selMarket == this.$store.getters.market.tdyMarket.key) {
				return this.todayTimer
			}
		},
    startAllBetTimer() {
			if (this.timerId == null) {
				this.timerId = setInterval(() => {
				if (this.timerSeconds - 1 < 0) {
					// this.reloadTable(token.arr_1)
					this.refreshTbl(token.arr_1)
				} else {
					this.timerSeconds -= 1;
				}
				}, 1000);
			}
		},
    refreshTbl(token_val) {
      this.reloading = (token_val == token.arr_1 || token_val == token.arr_5) ? false : true
      if (this.selectedMatchAllBet) {
        this.reloadAllBetTable(token_val)
      }
    },
    reloadAllBetTable(token_val = '') {
			if (token_val == '') {
				token_val = token.arr_5
			}
      this.clearTimer()
			// this.reloadingPer = '25%';
			this.cloneEventAllBet = _.cloneDeep(this.$store.getters.sortedMatchEventList)

			// this.reloadingPer = '80%';
			this.$store.dispatch('getSportAllBet', {
				token: token_val,
				inAllBet: true,
				event: this.$store.getters.sortedMatchEventList,
				callback: ((res) => {
				this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)

				this.startAllBetTimer()
				this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList)

				this.$nextTick(() => {
					EventBus.$emit('diffOdd', this.cloneEventAllBet)
				})
				this.reloading = false
				}).bind(this)
			})
		},
    checkTimer(event) {
      return this.$options.filters.checkTimer(event)
    },
  },
  mounted () {
    this.allBet_mContent()
  },
  beforeMount(){
    this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)
    this.startAllBetTimer()
  },
  destroyed () {
    this.clearTimer()
  },
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBetCommon.vue